import React from 'react';
import ShareTextModal from '../../common/ShareTextModal';
import { generateDownloadFilename } from '../../../utils/fileUtils';
import './Veo2Generator.scss';

const Veo2ResultPanel = ({ result, t, isGenerating }) => {
  const [shareOpen, setShareOpen] = React.useState(false);
  const getMeta = () => {
    const p = result?.payload || {};
    const ratio = p?.width && p?.height ? `${p.width}:${p.height}` : (p?.aspectRatio || '—');
    const created = p?.createdAt ? Date.parse(p.createdAt) : null;
    const completed = p?.completedAt ? Date.parse(p.completedAt) : null;
    let duration = '—';
    if (created && completed && completed > created) {
      const secs = Math.round((completed - created) / 1000);
      const m = Math.floor(secs / 60);
      const s = secs % 60;
      duration = m > 0 ? `${m}m ${s}s` : `${s}s`;
    }
    return `${ratio} • ${duration}`;
  };
  const handleDownload = async () => {
    try {
      const url = result?.src;
      if (!url) return;
      const resp = await fetch(url);
      const blob = await resp.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      const filename = generateDownloadFilename(result?.payload?.id);
      a.download = `${filename}.mp4`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectUrl);
    } catch (e) {
      const a = document.createElement('a');
      a.href = result?.src;
      const filename = generateDownloadFilename(result?.payload?.id);
      a.download = `${filename}.mp4`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  return (
    <div className={`veo2-preview ${result ? 'has-result' : ''}`}>
      {result ? (
        <div className="veo2-video" style={{ position: 'relative' }}>
          <video
            src={result.src}
            className="veo2-video__player"
            controls
            muted
          />
          <button
            onClick={() => {
              if (!result?.payload?.shareUrl) return;
              setShareOpen(true);
            }}
            disabled={!result?.payload?.shareUrl}
            style={{ position: 'absolute', top: 8, right: 8, width: 32, height: 32, borderRadius: 8, border: '1px solid #444', background: '#2a2a2a', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: result?.payload?.shareUrl ? 'pointer' : 'not-allowed', opacity: result?.payload?.shareUrl ? 1 : 0.6 }}
            aria-label={t('creationRecord.share')}
          >
            <img src="/icons/share.svg" alt={t('creationRecord.share')} style={{ width: 16, height: 16, filter: 'brightness(0) invert(1)', padding: 0 }} />
          </button>
          <div className="veo2-video__bar">
            <span className="veo2-video__label">{t('videoGeneration.veo.preview.resultLabel')}</span>
            <span className="veo2-video__meta">{getMeta()}</span>
            <button className="veo2-video__download" onClick={handleDownload}>
              {t('videoGeneration.veo.preview.download')}
            </button>
          </div>
          <ShareTextModal
            open={shareOpen}
            title={t('creationRecord.enterShareText')}
            placeholder={t('creationRecord.enterShareText')}
            maxLength={2000}
            platform={null}
            mediaUrl={result?.payload?.shareUrl || ''}
            mediaType="video"
            by=""
            onConfirm={() => { setShareOpen(false); }}
            onCancel={() => { setShareOpen(false); }}
          />
        </div>
      ) : (
        <div className="veo2-preview__empty">
          <div className="veo2-preview__icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="#16a34a" strokeWidth="1.5"/>
              <circle cx="8" cy="12" r="2" stroke="#16a34a" strokeWidth="1.5"/>
              <path d="M12 16l3-4 4 6" stroke="#16a34a" strokeWidth="1.5"/>
            </svg>
          </div>
          <h3>{t('videoGeneration.veo.preview.emptyTitle')}</h3>
          <p>{t('videoGeneration.veo.preview.emptyDesc')}</p>
          <span className="veo2-preview__hint">{t('videoGeneration.veo.preview.hint')}</span>
        </div>
      )}
      {isGenerating && (
        <div className="veo2-preview__mask">
          <div className="veo2-loading">
            <div className="veo2-spinner" />
            <span>{result ? t('videoGeneration.veo.preview.loadingRegenerate') : t('videoGeneration.veo.preview.loadingNew')}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Veo2ResultPanel;
